module.exports = __webpack_public_path__ + "img/pack_essentiel.ef7256f8.png";